<template>
  <div>
    <b-row size="lg" style="margin-top: 4em">
      <b-col style="max-width:70px">
        <v-icon scale="3" name="hdd" :spin="loading"></v-icon>
      </b-col>
      <b-col>
        <h2 class="text-secondary">
          <i>{{ device.imei }}</i>
        </h2>
        <h6 class="text-secondary">
          <i>{{ $t("globals.created") }}: {{ device.created_at.substring(0, 10) }}</i>
        </h6>
      </b-col>
      <!-- Actions -->
      <b-col>
        <b-btn
          v-if="getUserBrandPermissions.create_device_event"
          @click="createSoldEventModal.show = true"
          class="float-right m-1"
          size="sm"
          variant="success"
        >
          {{ $t("globals.create_sold_event") }}
        </b-btn>
        <b-btn
          v-if="showStockBtn"
          @click="stock"
          class="float-right m-1"
          size="sm"
          variant="info"
        >
          {{ $t("globals.stock") }}
        </b-btn>
      </b-col>
    </b-row>
    <!-- Modals -->
    <ulu-create-sold-event-modal
      :show="createSoldEventModal.show"
      :close="closeModals"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    "ulu-create-sold-event-modal": () =>
      import("@/components/devices/device/device_header/AddSoldEventModal.vue")
  },
  props: {
    refresh: Function,
    loading: Boolean,
    device: {
      type: Object,
      default: () => ({
        imei: "",
        created_at: "",
        status: ""
      })
    }
  },
  data() {
    return {
      createSoldEventModal: {
        show: false
      }
    }
  },
  methods: {
    ...mapActions("axios_mod", ["simpleMutation"]),
    stock() {
      let data = {
        query: `
          mutation { 
            res: DeviceBackToStock (
              device_id: ${parseInt(this.$route.params.id)}
            )
          }
        `
      };

      this.simpleMutation({ data, this_ref: this }).then(() => {
        this.refresh();
      });
    },
    closeModals() {
      this.createSoldEventModal.show = false;
      this.refresh();
    }
  },
  computed: {
    ...mapGetters(["getUserBrandPermissions"]),
    showStockBtn() {
      return (
        this.device.status == 'terminated'
        || this.device.status == 'warranty'
      )
    }
  }
};
</script>
